// @flow
import { getCampaignBooking } from './basicCreators';
import { APIError } from '../generalCreators';

export function updateCurrentCampaignBooking(
  campaignId: number,
  organisationId: number
): any {
  return function(dispatch) {
    if (campaignId) {
      // Get the campaign details
      return dispatch(getCampaignBooking(campaignId, organisationId)).then(
        response =>
          dispatch({
            type: 'UPDATE_CURRENT_CAMPAIGN_BOOKING',
            booking: response
          }),
        error => dispatch(APIError(error, 'Error updating current Campaign'))
      );
    } else {
      const result = dispatch({ type: 'CLEAR_CURRENT_CAMPAIGN_BOOKING' });
      return Promise.resolve(result);
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/campaigns/currentCampaignBookingCreators.js